import { Component, OnInit } from '@angular/core';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-final-pronouncement',
  templateUrl: './final-pronouncement.component.html'
})
export class FinalPronouncementComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getFinalPronouncement();
  }
  header;
  contentlinks;
  finalpronouncementlink = [];
  getFinalPronouncement() {
    this.graphQlService.getpronouncements("", false).subscribe(data => {
      this.contentlinks = data.result;
      this.header = data.header;
      //const div = document.getElementById("mainText");
      //div.innerHTML=(this.contentlinks);
      this.commonDataService.showLoader.next(false);
    })
  }

}
